import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";
export async function MarcaVehiculoCreateAction(
  formData: FormData
): Promise<ApiResponse<MarcaVehiculoInterface>> {
  const { data } = await apiClient.post<MarcaVehiculoInterface>(
    "/gvMarcaVehiculos",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return {
    status: 200,
    data,
    message: "Marca de vehículo creada correctamente",
  };
}
